import { render, staticRenderFns } from "./Odr.vue?vue&type=template&id=713fc69d&scoped=true&"
import script from "./Odr.vue?vue&type=script&lang=js&"
export * from "./Odr.vue?vue&type=script&lang=js&"
import style0 from "./Odr.vue?vue&type=style&index=0&id=713fc69d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713fc69d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713fc69d')) {
      api.createRecord('713fc69d', component.options)
    } else {
      api.reload('713fc69d', component.options)
    }
    module.hot.accept("./Odr.vue?vue&type=template&id=713fc69d&scoped=true&", function () {
      api.rerender('713fc69d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/Odr.vue"
export default component.exports